import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Icon from "material-ui-next/Icon";
import IconButton from "material-ui-next/IconButton";
import Typography from "material-ui-next/Typography";
import Dialog, {
  DialogTitle,
  DialogContent,
  DialogActions
} from "material-ui-next/Dialog";
import List, { ListItem, ListItemText } from "material-ui-next/List";
import {
  StyledButton,
  Loadable,
  TextField,
  Avatar,
  If
} from "components/support";
import styles from "./styles";

class EntitySelector extends Component {
  entityEntry = entity => {
    const { parser, presenter } = this.props;
    const parsedEntity = parser(entity);

    return (
      <ListItem
        button
        key={parsedEntity.key}
        onClick={() => presenter.onSelect(entity)}
      >
        <If test={!parsedEntity.key}>
          <If test={parsedEntity.title.substring(0, 7) === "Remover"}>
            <Icon style={{ ...styles.dummyIcon }}>close</Icon>
          </If>

          <If test={parsedEntity.title.substring(0, 7) !== "Remover"}>
            <Avatar name={parsedEntity.title} />
          </If>

          <ListItemText primary={parsedEntity.title} />
        </If>

        <If test={parsedEntity.key}>
          <Avatar name={parsedEntity.title} />
          <ListItemText
            primary={parsedEntity.title}
            secondary={parsedEntity.subtext}
          />
        </If>
      </ListItem>
    );
  };

  resultList = () => {
    const { entityList } = this.props.viewModel;

    if (entityList.length === 0) {
      return (
        <Typography type="subheading" align="center">
          Nenhum resultado foi encontrado
        </Typography>
      );
    } else {
      
      return <List>{entityList.map(entity => this.entityEntry(entity))}</List>;
    }
  };

  render() {
    const {
      presenter,
      viewModel,
      label,
      error,
      value,
      title,
      disabled,
      errorText,
      noMargin,
      hideField = false,
      open,
      textDisabled,
      placeholder = "",
      allowClose = true,
    } = this.props;
    const { listVisible, loading, filter } = viewModel;

    const additionalStyles = {};

    if (disabled) {
      additionalStyles.cursor = "not-allowed";
    }

    return (
      <div style={noMargin ? {} : styles.textFieldContainer}>
        <If test={!hideField}>
          <Row bottom="xs">
            <Col xs onClick={() => presenter.onEdit()}>
              <TextField
                fullWidth
                value={value}
                label={label}
                errorText={error}
                noMargin
                disabled={disabled || textDisabled || false}
                placeholder={placeholder}
              />
            </Col>
            <Col>
              <div style={styles.actionsContainer}>
                <IconButton
                  style={{ ...styles.actionButton, ...additionalStyles }}
                  onClick={() => !disabled && presenter.onEdit()}
                >
                  <Icon>mode_edit</Icon>
                </IconButton>

                <If test={value && value.length}>
                  <IconButton
                    style={{ ...styles.actionButton, ...additionalStyles }}
                    onClick={() => !disabled && presenter.onClear()}
                  >
                    <Icon>clear</Icon>
                  </IconButton>
                </If>
              </div>
            </Col>
            <Col xs={12}>
              <If test={errorText && errorText.length > 0}>
                <p className="error-text-message" style={styles.errorText}>
                  {errorText}
                </p>
              </If>
            </Col>
          </Row>
        </If>

        <Dialog
          open={open || listVisible}
          onClose={() => presenter.onListClose()}
        >
          <DialogTitle>{title}</DialogTitle>

          <If test={!hideField}>
          <div style={styles.search}>
            <TextField
              fullWidth
              autoFocus
              placeholder="Pesquisar"
              value={filter}
              onChange={(_, value) => presenter.onUpdateFilter(value)}
            />
          </div>
          </If>

          <DialogContent style={styles.dialogContent}>
            <Loadable loading={loading} customSize={25} customThickness={6}>
              {this.resultList()}
            </Loadable>
          </DialogContent>

          <If test={allowClose}>
          <DialogActions>
            <StyledButton
              flat
              label="Fechar"
              onClick={() => presenter.onListClose()}
            />
          </DialogActions>
          </If>
        </Dialog>
      </div>
    );
  }
}

export default EntitySelector;



// WEBPACK FOOTER //
// ./src/components/support/entity-selector/view.jsx